<template>
  <div>
    <!-- 微信认证组件 -->
    <wxAuth :share="share"></wxAuth>
    <!-- title -->
    <headers :params="hraderP"></headers>
    <!-- 搜索框 -->
    <search :param="searchParam" @callback="callback" ref="search"></search>
    <!-- 方案列表 -->
    <div v-show="!noData && solutions.length > 0">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :offset="80"
        @load="onLoad"
      >
        <div class="list-content">
          <van-row class="list-item" v-for="(item, index) of solutions" :key="index">
            <router-link :to="`/solutions/detail/${item.solutionId}.html?buildingType=${buildingType}&buildingTypeId=${buildingTypeId}&firstSysAttr=${firstSysAttr}&firstSysAttrId=${firstSysAttrId}`">
              <van-col :span="18">
                <van-row  class="list-item-title">
                  <div> {{item.solutionName}}</div>
                </van-row>
                <van-row class="list-item-count">
                  <div> <span>{{item.pageView | myriabit}}</span>&nbsp;阅读量</div>
                </van-row>
              </van-col>
              <van-col :span="6" class="list-item-title"><img v-if="item.matchPic" :src="item.matchPic | getImageUrl" alt=""></van-col>
            </router-link>
          </van-row>
        </div>
      </van-list>
    </div>
    <noResult v-show="noData && solutions.length <= 0" :noResultData="noResultData" @toListSelf="toListSelf"></noResult>
  </div>
</template>

<script>
import headers from '@/components/headers'
import search from '@/components/search'
import { List } from 'vant'
import wxAuth from '@/components/wxAuth'
import noResult from '@/components/noResult'
import { myriabit, getImageUrl } from '@/filters/commonFilters'
import { mapState } from 'vuex'
export default {
  name: 'solution-list',
  filters: { myriabit, getImageUrl },
  components: { search, List, wxAuth, noResult, headers },
  data () {
    return {
      share: {
        title: '解决方案馆',
        desc: '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
        imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0]
      },
      hraderP: {
        title: '解决方案馆',
        lefticon: true
      },
      searchParam: {
        type: 'search03', // 必传
        placeholder: '', // 选传
        callback: 'callback', // 必传 （父组件接收子组件抛出数据 方法名称）
        filterType: 'sol', // 必传  （news/sol   资讯/方案）
        url: '/hadoop/list.html'
      },
      loading: false,
      finished: false,
      params: {
        page: 1,
        pageSize: 10,
        brandId: '',
        buildingType: '',
        firstSysAttr: ''
      },
      solutions: [],
      noData: false,
      noResultData: {
        typeName: '方案',
        callback: 'callback'
      },
      buildingType: '',
      buildingTypeId: '',
      firstSysAttr: '',
      firstSysAttrId: ''
    }
  },
  computed: {
    ...mapState({
      hotKeyWord: state => state.solution.keyWords
    })
  },
  watch: {
    hotKeyWord (newV, old) {
      if (newV && newV.length > 0) {
        this.$data.searchParam.placeholder = newV
      }
    }
  },
  created () {
    this.$store.dispatch('BASE_DATA_GET_BRANDS')
    this.$store.dispatch('BASE_DATA_GET_COMMONDATA', 5)
    this.$store.dispatch('BASE_DATA_GET_COMMONDATA', 6)
    this.$store.dispatch('SOLUTIONS_GET_KEYWORD')
    // 建筑业态
    if (this.$route.query.buildingType) {
      this.params['buildingType'] = this.$route.query.buildingTypeId
      this.buildingType = this.$route.query.buildingType
      this.buildingTypeId = this.$route.query.buildingTypeId
    }
    // 系统属性
    if (this.$route.query.firstSysAttr) {
      this.params['firstSysAttr'] = this.$route.query.firstSysAttrId
      this.firstSysAttr = this.$route.query.firstSysAttr
      this.firstSysAttrId = this.$route.query.firstSysAttrId
    }
    this.getData()
  },
  methods: {
    callback (event) {
      let self = this
      delete self.params.firstSysAttr
      delete self.params.buildingType
      delete self.params.brandId
      this.buildingType = ''
      this.buildingTypeId = ''
      this.firstSysAttr = ''
      this.firstSysAttrId = ''
      self.finished = false
      this.solutions = []
      this.noData = false
      if (event) {
        event.forEach(item => {
          if (item.type === 'PP' && item.id !== 0) {
            this.params['brandId'] = item.id
          }
          // 建筑业态
          if (item.type === 'YT' && item.id !== 0) {
            this.params['buildType'] = item.id
            this.buildingType = item.name
            this.buildingTypeId = item.id
          }
          // 系统属性
          if (item.type === 'SX' && item.id !== 0) {
            this.params['firstSysAttr'] = item.id
            this.firstSysAttr = item.name
            this.firstSysAttrId = item.id
          }
        })
      }
      this.params['page'] = 1
      this.params['pageSize'] = 10
      this.$store.dispatch('SOLUTIONS_GET_LIST', this.params).then(result => {
        if (result && result.status === 200 && result.data && result.data.data && result.data.data.solutions && result.data.data.solutions.length > 0) {
          self.solutions = result.data.data.solutions
          self.loading = false
          if (result.data.data.page >= result.data.data.pages) {
            self.finished = true
          }
        } else {
          self.loading = false
          self.finished = true
          this.noData = true
        }
      })
    },
    onLoad () {
      // 调用查询接口
      let self = this
      this.params.page++
      this.$store.dispatch('SOLUTIONS_GET_LIST', this.params).then(result => {
        if (result && result.status === 200 && result.data && result.data.data && result.data.data.solutions && result.data.data.solutions.length > 0) {
          self.solutions = self.solutions.concat(result.data.data.solutions)
          self.params.page = result.data.data.page.page
          window.setTimeout(() => {
            self.loading = false
            if (result.data.data.page >= result.data.data.pages) {
              self.finished = true
            }
          }, 1000)
        } else {
          self.loading = false
          self.finished = true
        }
      })
    },
    getData () {
      if (!this.params.firstSysAttr || this.params.firstSysAttr === '') {
        delete this.params.firstSysAttr
      }
      if (!this.params.buildingType || this.params.buildingType === '') {
        delete this.params.buildingType
      }
      if (!delete this.params.brandId || delete this.params.brandId === '') {
        delete delete this.params.brandId
      }
      this.params.page = 0
      this.params.pageSize = 10
      this.finished = false
      this.noData = false
      this.onLoad()
    },
    toListSelf () {
      delete this.params.firstSysAttr
      delete this.params.buildingType
      delete this.params.brandId
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.list-content{
  background-color: white;
  padding-left: 15px;
  padding-right: 15px;
  border-bottom: 1px solid #D8D8D8;
  .list-item{
    border-bottom: 1px solid #D8D8D8;
    padding-top: 15px;
    &:last-child{
        border-bottom: none;
     }
    &-title{
      color: #222222;
      font-size: 14px;
      margin-bottom: 6px;
     img{
       width: 90px;
       height: 61px;
     }
      div{
        height: 40px;
        display: inline-block;
        max-width: 95%;
        vertical-align: middle;
        text-overflow: ellipsis;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      & i{
          margin-left: 8px;
          border: 1px solid #1DBFDA;
          position: relative;
          font-size: 10px;
          padding: 0 5px;
          box-sizing: border-box;
          color: #1DBFDA;
          border-top-left-radius: 2px;
          border-top-right-radius: 2px;
          border-bottom-right-radius: 2px;
          font-style: inherit;
          &::before{
             position: absolute;
             left: -5px;
             bottom: -1px;
             content: '';
             width:0;
             border-top:4px solid white;
             border-right:4px solid #1DBFDA;
           }
           &::after{
              position: absolute;
              left: -2px;
              bottom: 0px;
              content: '';
              width:0;
              border-top:2px solid transparent;
              border-right:2px solid white;
            }
        }
    }
     &-describe{
        color: #999999;
        font-size: 13px;
        height: 18px;
        line-height: 18px;
        margin-bottom: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &-count{
        margin-bottom: 15px;
        font-size: 10px;
        color: #a0a0a0;
        height: 14px;
        line-height: 14px;
        & span{
            color: #f8a325;
          }
       }
  }
}
.no-data-content{
  background-color: #f5f5f5;
  text-align: center;
  padding-top: 111px;
  .describe-content{
    p{
      font-size: 14px;
      color: #a0a0a0;
      margin: 0px;
    }
  }
  .button-content{
    button{
      margin-top: 40px;
      width: 200px;
      height: 44px;
      background-color: #1dbfda;
      color: white;
      border: none;
      border-radius: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/solutions/list.vue